import { Component } from '@angular/core';
import {NavController, Platform} from '@ionic/angular';
//import {SplashScreen} from '@awesome-cordova-plugins/splash-screen/ngx';
//import {ScreenOrientation} from '@awesome-cordova-plugins/screen-orientation/ngx';
import {Storage} from '@ionic/storage';
import {StorageService} from './util/storage.service';
import {STRG_KEYS} from './app.config';
import {AndroidPermissions} from "@awesome-cordova-plugins/android-permissions/ngx";
import {DeviceProviderService} from "./util/device-provider.service";
import {User} from "./models/User";
//import {AndroidPermissions} from '@awesome-cordova-plugins/android-permissions/ngx';
//import {FCM} from "@awesome-cordova-plugins/fcm/ngx";

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  version: string;
  isWeb: boolean = false;
  constructor(
    public storage: Storage,
    public storageService: StorageService,
    public navCtrl: NavController,
    public deviceProvider: DeviceProviderService,
    //private splashScreen: SplashScreen,
    //private screenOrientation: ScreenOrientation,
    private platform: Platform,
    //private screenOrientation: ScreenOrientation,
    private androidPermissions: AndroidPermissions,
    //private fcm: FCM
  ) {
    platform.ready().then(async () => {
      await this.storage.create();

      if(platform.is('pwa') || platform.is('mobile')
        || platform.is('mobileweb') || platform.is("desktop")){
        console.log("is Web");
        this.isWeb = true;
        this.deviceProvider.setIsWeb(true);
      }

      if(!this.isWeb) {
        this.androidPermissions.requestPermissions(
          [
            androidPermissions.PERMISSION.CAMERA,
            androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE,
            androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
          ]
        );
      }

      //this.splashScreen.hide();
      //await this.screenOrientation.lock('portrait');
      //this.pushNotifications();
      /*this.androidPermissions.requestPermissions(
        [
          this.androidPermissions.PERMISSION.CAMERA,
          this.androidPermissions.PERMISSION.READ_EXTERNAL_STORAGE,
          this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE
        ]
      );*/
      this.storage.get(STRG_KEYS.DATA_USER).then((dUser) => {
        if (dUser) {
          this.storage.get(STRG_KEYS.DATA_OT).then((ots) => {
            if (ots) {
              this.storage.get(STRG_KEYS.DATA_HSEQ).then((hseq) => {
                if (hseq) {
                  this.storage.get(STRG_KEYS.DATA_ETAPAS).then((etapas) => {
                    this.storage.get(STRG_KEYS.DATA_SYNC_OT).then((syncs) => {
                      if (syncs) {
                        this.storage.get(STRG_KEYS.DATA_APP_CONF).then((confApp) => {
                          if (confApp) {
                            this.storage.get(STRG_KEYS.DATA_DOCUMENTACION).then((documentacion) => {
                              if (documentacion) {
                                this.deviceProvider.setData(dUser.device, dUser.id, dUser.user, dUser.password, dUser.token);
                                this.storageService.setOTs(ots);
                                this.storageService.setHSEQ(hseq);
                                this.storageService.setEtapas(etapas);
                                this.storageService.setConfApp(confApp);
                                this.storageService.setDataSync(syncs);
                                this.storageService.setDocumentacion(documentacion);
                                this.navCtrl.navigateRoot('/home', {skipLocationChange: true});
                              } else {
                                this.navCtrl.navigateRoot('/login', {skipLocationChange: true});
                              }
                            });
                          } else {
                            this.navCtrl.navigateRoot('/login', {skipLocationChange: true});
                          }
                        });
                      } else {
                        this.navCtrl.navigateRoot('/login', {skipLocationChange: true});
                      }
                    });
                  });
                }
              });
            }
            else {
              this.navCtrl.navigateRoot('/login', {skipLocationChange: true});
            }
          });
        }
        else {
          this.navCtrl.navigateRoot('/login', {skipLocationChange: true});
        }
      });
    });
  }

  initializeApp() {

  }

  /*pushNotifications(){
    // subscribe to a topic
    // this.fcm.subscribeToTopic('Deals');
    // get FCM token
    this.fcm.getToken().then(token => {
      console.log(token);
    });
    // ionic push notification example
    this.fcm.onNotification().subscribe(data => {
      console.log(data);
      if (data.wasTapped) {
        console.log('Received in background');
      } else {
        console.log('Received in foreground');
      }
    });
    // refresh the FCM token
    this.fcm.onTokenRefresh().subscribe(token => {
      console.log(token);
    });
    // unsubscribe from a topic
    // this.fcm.unsubscribeFromTopic('offers');
  }*/
}
